module.exports = "*:not(p) {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    width: initial;\n}\n\nli{\n    list-style: none;\n}\n\np:first-child{\n    margin-top: 0;\n}\n\nimg{\n    margin-bottom: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/layouts/reset.css
// module id = 143
// module chunks = 32977039424393 114276838955818